import React from 'react';
// Constants
import {
  CompanyName,
  CompanyPhoneNumber,
  ContactEmailAddress,
  DirectorName,
  LocationCity,
  LocationCountry,
} from '../../utils/Constants';
// Images
import ImageOne from '../../assets/images/main/ascari-building-contractors-landscaping-and-carpentry-frame-small.jpg';
import ImageTwo from '../../assets/images/main/ascari-building-contractors-landscaping-and-carpentry-roofing.jpg';
import ImageThree from '../../assets/images/main/ascari-building-contractors-landscaping-and-carpentry-interior.jpg';
import ImageFour from '../../assets/images/main/ascari-building-contractors-bathroom-hero.avif';

const images = [ImageOne, ImageTwo, ImageThree, ImageFour];

function AboutSection() {
  return (
    <section className='grid w-full'>
      <div className='grid gap-8 lg:gap-16 lg:grid-cols-2 w-full px-6 sm:px-8 md:px-16 lg:container lg:mx-auto'>
        <section className='grid'>
          <article className='grid gap-4 text-center lg:text-left'>
            <h4 className='text-2xl font-semibold'>
              {CompanyName} <br /> Quality Craftsmanship You Can Trust
            </h4>
            <p className='mt-4 text-lg'>
              With over 20 years of experience in the building trade,{' '}
              {DirectorName} and the team at {CompanyName} provide expert
              construction services across {LocationCity} and the wider{' '}
              {LocationCountry} region. From carpentry and bathrooms to
              groundworks and full-scale building projects, we take pride in
              delivering high-quality results with a commitment to reliability
              and excellence.
            </p>
            <p className='mt-2 text-lg'>
              Whether you're planning a new build, an extension, or renovations,
              we have the skills and experience to bring your vision to life.
              Our work is built on precision, durability, and customer
              satisfaction.
            </p>
            <div className='mt-6'>
              <a
                href={`tel:${CompanyPhoneNumber}`}
                className='px-4 py-2 bg-colour6 text-white rounded-md shadow-md hover:bg-colour5 transition'
              >
                Call Now: {CompanyPhoneNumber}
              </a>
            </div>
            <div className='mt-2'>
              <a
                href={`mailto:${ContactEmailAddress}`}
                className='text-colour6 underline'
              >
                Email: {ContactEmailAddress}
              </a>
            </div>
          </article>
        </section>

        {/* Images */}
        <section className='grid'>
          <div className='grid grid-cols-2 grid-rows-2 gap-2'>
            {images.map((image, index) => (
              <div key={index} className='grid'>
                <img
                  src={image}
                  alt={`${CompanyName} - Work Example ${index + 1}`}
                  className='rounded-lg shadow-md h-full object-cover'
                />
              </div>
            ))}
          </div>
        </section>
      </div>
    </section>
  );
}

export default AboutSection;
